// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"d04918e4","384":"c195db3e","438":"a5f64ec3","706":"a60d4d3a","726":"3b533efe","996":"23acacba"}[chunkId] + ".chunk.js";
};